const ChatIconSvg = ({size = 60, color = 'black'}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        transform="matrix(-1,0,0,1,0,0)"
    >
        <path
            d="M17.94 30c0-3.183 1.25-6.235 3.479-8.485a11.82 11.82 0 0 1 8.4-3.515c3.15 0 6.171 1.264 8.399 3.515A12.06 12.06 0 0 1 41.698 30v7.635c0 1.272 0 1.905-.188 2.413a3 3 0 0 1-.682 1.073c-.301.305-.664.54-1.062.69-.504.189-1.132.189-2.39.189h-7.558c-3.15 0-6.172-1.264-8.4-3.515A12.06 12.06 0 0 1 17.94 30Z"
            stroke={color}
            strokeWidth={2}
        />
        <path
            d="M25.364 28.5h8.909m-4.455 6h4.455"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ChatIconSvg;